module.exports = __webpack_public_path__ + "img/defaultAvatar.90d2dbce.png";